import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { ProductVariantGuard } from './guards';
import { ProductVariantsComponent } from './product-variants.component';
import { VariantColorSelectorModule } from './variant-color-selector/variant-color-selector.module';
import { VariantSizeSelectorModule } from './variant-size-selector/variant-size-selector.module';
import { VariantStyleIconsModule } from './variant-style-icons/variant-style-icons.module';
import { VariantStyleSelectorModule } from './variant-style-selector/variant-style-selector.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    VariantStyleSelectorModule,
    VariantSizeSelectorModule,
    VariantColorSelectorModule,
    VariantStyleIconsModule,
    ProductVariantsComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductVariantSelectorComponent: {
          component: ProductVariantsComponent,
          guards: [ProductVariantGuard],
        },
      },
    }),
  ],
  exports: [ProductVariantsComponent],
})
export class ProductVariantsModule {}
